/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{Uniform as r}from"../../../../webgl/Uniform.js";class o extends r{constructor(r,o){super(r,"int",0,(s,t)=>s.setUniform1i(r,o(t)))}}export{o as IntegerBindUniform};
